import m from "mithril";
import {filesize} from 'filesize'

import {
	defineWidget,
	Empty,
	CardieWidget,
	FileSelectButton,
	Notification,
	ButtonNew,
	InputWidget
} from "@nebularstreams/libmui"

import {loadContent, sortContent} from "../../Api";
import {initUpload, uploadFile} from "./Uploader";

// utility: load the bucket contents
function loadBucket(orga, STATE) {

	const {perorga, streamname, type} = STATE;
	STATE.loadingContent = true;

	m.redraw();
	loadContent(STATE, perorga ? orga : streamname, type)
		.finally(() => {
			STATE.loadingContent = false;
			m.redraw()
		});
}

const

	getSortText = (i) => {
		return i === 2 ? "date" : i === 1 ? "size" : "name"
	},

	// widget: Bucket List
	ContentBrowser = defineWidget(
		({attrs, state}) => {

			const
				list = attrs.state.content?.list;
			let
				filtered = list;

			if (list && state.filter?.length > 2 && !state.filtered) {
				filtered = list.filter((item) => item.key.indexOf(state.filter) >= 0);
			}

			return m(CardieWidget,
				{
					cols: true,
					class: "bucketlist",
					element: "div",
					title: (attrs.title ? attrs.title + " " : "") + (attrs.state.content?.size ? `(${filesize(attrs.state.content.size)})` : ""),
					bodyClass: "scrolly",
					collapsed: attrs.collapsed,
					nofold: attrs.nofold,
					...attrs.noUpload || {
						alwaysView: () => m(".flexrow.footer", [
							...attrs.state.content?.list?.length ? [
								m(ButtonNew, {
									icon: "arrow-down",
									class: "unitheight sortbutton",
									text: getSortText(attrs.state.content?.sort),
									onClick: () => {
										sortContent(attrs.state.service, 1);
										m.redraw();
									}
								}),
								...attrs.filter ? [
									m(InputWidget, {
										containerClass: "w-100 searchfooter",
										class: "searchbox unitheight",
										value: state.filter || "",
										icon: "search",
										hint: "search",
										maxlength: 32,
										onchange: (value) => {
											state.filter = value;
											m.redraw();
										}
									})
								] : []
							] : [],

							m(FileSelectButton, {
								class: "grows",
								text: attrs.uploadMessage || "Upload from your computer",
								accept: attrs.accept,
								onFile: (file) => {
									uploadFile(attrs.state, file, {loop: false})
										.then(() => loadBucket(attrs.orga, attrs.state))
										.catch((e) => Notification.add(e.message))
										.finally(() => m.redraw());
								}
							}),

						])
					}
				},
				[
					...attrs.state.uploadingFiles?.length
						? [
							m("ul.flexcol.w-100.uploading",
								attrs.state.uploadingFiles.map((item) => m("li.uploadingvideo", {
										id: item.id,
										"data-file": item.file
									}, [
										m(".progress", {
											style: {
												width: `${item.percentage || 0}%`
											}
										})
									])
								)
							)]
						: [],

					...attrs.state.loadingContent
						? [m(Empty, {icon: "sync.fa-spin", size: 2, class: "pad-2"})]
						: filtered?.length
							? [
								m("ul.flexcol.grows.w-100",
									filtered
										.map((item) => m(attrs.itemWidget, {
											item,
											webroot: attrs.state.content.webroot,
											service: attrs.service,
											prefix: attrs.prefix,
											state: attrs.state,
											nopreview: attrs.nopreview
										})))
							]
							: attrs.state.content?.ts
								? [m(Empty, {
									size: 2,
									icon: attrs.icon || "video-slash",
									message: (state.filter ? attrs.emptyFilter : attrs.emptyMessage) || "No items in your nanoStream Storage"
								})]
								: []
				]
			)
		},
		({attrs})=>{
			if (attrs.loadContent) loadBucket(attrs.orga, attrs.state);
		},
		({attrs, dom}) => attrs.noUpload || initUpload(attrs.state, dom, {
			refresh: () => m.redraw(),
			onUpload: () => loadBucket(attrs.orga, attrs.state)
		})
	);

export {ContentBrowser}
